import { Record } from "@mail/core/common/record";

export class ResGroupsPrivilege extends Record {
    static _name = "res.groups.privilege";
}

ResGroupsPrivilege.register();
